import { IS_CLIENT } from '../constants';
/**
 * Get stored value from cookie, automatically decodes encoded cookie value.
 * @param {string} - name of cookie
 * @returns {(string|null)} - data from cookie or null if cookie does not exist
 */
const getCookie = (name) => {
    if (!IS_CLIENT) {
        return null;
    }
    const matchedCookie = document.cookie.match(RegExp(`${name}=(.[^;]*)`));
    if (Array.isArray(matchedCookie) && matchedCookie[1]) {
        /* cookieValue :: [] -> str
         * get the value from the cookie */
        const cookieValue = matchedCookie[1];
        /* cookies that is base64 encoded will start with ## and end with ## */
        const isBase64Encoded = cookieValue.match(RegExp(`^##.*##$`));
        if (isBase64Encoded) {
            /* Window atob method :: The atob() method decodes a base-64 encoded string */
            return atob(cookieValue.replace(/#/g, ''));
        }
        return cookieValue;
    }
    return null;
};
export default getCookie;
//# sourceMappingURL=getCookie.js.map